import './input.css'
import RequiredMark from './RequiredMark'

function Textarea({
    text,
    name,
    placeholder,
    handleOnChange,
    value,
    disabled,
    required,
    rows,
}) {

    return (
        <div>
            {text &&
                <label htmlFor={name}>{text}:{required && <RequiredMark />}</label>
            }
            <div className='input-box'>
                <textarea
                    className="input textarea"
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    onChange={handleOnChange}
                    value={value}
                    disabled={disabled}
                    rows={rows || 4}
                />
            </div>
        </div>
    )
}

export default Textarea
